export default [
  { label: 'Prompt', value: 'prompt' },
  { label: 'Message', value: 'message' },
  { label: 'Queue', value: 'call_queue' },
  { label: 'Callback', value: 'callback' },
  { label: 'Voicemail', value: 'voicemail' },
  { label: 'Extension Directory', value: 'extensions' }
];
